/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/LoopAround/theme';

export const LoopAroundTheme = theme;
